/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://e3vmbgycp5c2vfunofxvkvzpme.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-wqpqhk3yubcilnma7uw7kkpxyq",
    "aws_cloud_logic_custom": [
        {
            "name": "invitationAPI",
            "endpoint": "https://v4vpqe1zqd.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:39c76136-e944-40d9-96cb-1d0b72fe0454",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_AI96P9gF4",
    "aws_user_pools_web_client_id": "lbdt3nmtm1al9fssegco3fnaf",
    "oauth": {
        "domain": "banjara48b37661-48b37661-prod.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/auth/callback/,https://www.banjara-app.com/auth/callback/,https://banjara-app.com/auth/callback/",
        "redirectSignOut": "http://localhost:3000/,https://www.banjara-app.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "banjara-20250303141308-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://duf6tjl9kfztl.cloudfront.net",
    "aws_user_files_s3_bucket": "banjara-photos-f3011d4c-23b6-493a-8664be4ca-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
